// in case we need this somewhere else, we can extract this into a separate file

// Local storage keys for modal tracking
const MODAL_STORAGE_KEYS = {
	TRIGGER_COUNT: "CWS_MODAL_COUNT",
	LAST_TRIGGER_DATE: "CWS_MODAL_DATE",
};

export default {
	data() {
		return {
			showScrollModal: false,
			scrollData: {
				maxScrollY: 0,
				hasScrolledDown: false,
				hasScrolledUp: false,
			},
		};
	},
	mounted() {
		this.initializeScrollTracking();
	},
	destroyed() {
		this.removeScrollListener();
	},
	methods: {
		// Scroll tracking methods
		initializeScrollTracking() {
			if (process.client) {
				this.addScrollListener();
				this.checkModalEligibility();
			}
		},

		addScrollListener() {
			window.addEventListener("scroll", this.handleScroll, {
				passive: true,
			});
		},

		removeScrollListener() {
			if (process.client) {
				window.removeEventListener("scroll", this.handleScroll);
			}
		},

		handleScroll() {
			const scrollY = window.scrollY;

			// Track maximum scroll position
			if (scrollY > this.scrollData.maxScrollY) {
				this.scrollData.maxScrollY = scrollY;
			}

			// Check if user has scrolled down at least 200px
			if (scrollY >= 200 && !this.scrollData.hasScrolledDown) {
				this.scrollData.hasScrolledDown = true;
			}

			// Check if user is now scrolling up after having scrolled down
			if (
				this.scrollData.hasScrolledDown &&
				scrollY < this.scrollData.maxScrollY
			) {
				this.scrollData.hasScrolledUp = true;
				this.checkModalTrigger();
			}
		},

		checkModalEligibility() {
			const triggerCount = this.getModalTriggerCount();
			const lastTriggerDate = this.getLastTriggerDate();
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

			// Check if modal should be eligible to show
			const canShowModal =
				triggerCount < 3 &&
				(!lastTriggerDate || new Date(lastTriggerDate) < thirtyDaysAgo);

			if (!canShowModal) {
				this.removeScrollListener();
			}
		},

		checkModalTrigger() {
			if (this.showScrollModal) {
				return;
			}

			const triggerCount = this.getModalTriggerCount();
			const lastTriggerDate = this.getLastTriggerDate();
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

			// Check conditions for showing modal
			if (
				triggerCount < 3 &&
				(!lastTriggerDate || new Date(lastTriggerDate) < thirtyDaysAgo)
			) {
				this.showScrollModal = true;
				this.updateModalTriggerData();
				this.removeScrollListener(); // Stop tracking after showing
			}
		},

		closeScrollModal() {
			this.showScrollModal = false;
		},

		// Local storage methods
		getModalTriggerCount() {
			if (process.client) {
				const count = localStorage.getItem(
					MODAL_STORAGE_KEYS.TRIGGER_COUNT
				);
				return count ? parseInt(count, 10) : 0;
			}
			return 0;
		},

		getLastTriggerDate() {
			if (process.client) {
				return localStorage.getItem(
					MODAL_STORAGE_KEYS.LAST_TRIGGER_DATE
				);
			}
			return null;
		},

		updateModalTriggerData() {
			if (process.client) {
				const currentCount = this.getModalTriggerCount();
				localStorage.setItem(
					MODAL_STORAGE_KEYS.TRIGGER_COUNT,
					(currentCount + 1).toString()
				);
				localStorage.setItem(
					MODAL_STORAGE_KEYS.LAST_TRIGGER_DATE,
					new Date().toISOString()
				);
			}
		},
	},
};
